import ls from "localstorage-slim";
import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    jwt: ls.get("jwt", { decrypt: true }) ?? null,
    refreshToken: ls.get("refreshToken", { decrypt: true }) ?? null,
  });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
